import { useState, useEffect, useRef, Suspense, useMemo, useCallback } from "react";
import { Toast } from "primereact/toast";
import LoadingOverlay from "react-loading-overlay-ts";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import MaterialsListHeader from "./MaterialsListHeader";
import MaterialsNameHeader from "./MaterialsNameHeader";
import CreateViewDialog from "../../CreateViewDialog";
import { getDashboardModuleDetails } from "../../../../apis/dashboardApi";
import {
  multiFilterChange,
  checkIfObjectOrderSame,
  bufferToWork,
  changeDateFormat,
  sortColumns,
} from "../../../../utils";
import _, { isEmpty } from "lodash";
import { cicImage, materialsExportCSVFlags, getStatusFlags } from "./utils";
import AlertIcon from "../../../common/AlertIcon/AlertIcon";
import { dsbpConstant } from "../../../../components/DSBP/constant";
import { projectIdCell, projectNameCell, artworkStatusCell } from "../../CommonGrid/cellTemplates";
import { getBaseUrl } from "../../ModuleGrids/gridConfig";
import Footer from "../../../common/tableFooter/tableFooter";
import * as types from "../../../../store/types/types";

import {
  hallowGreyCircle,
  hallowRedCircle,
  inProgressLate,
  redCross,
  greenV,
  hallowGreenCircle,
  solidGreenCircle,
  UnallocatedHallowGreyCircle,
  UnallocatedSolidGreenCircle,
  UnallocatedNA,
  NA,
} from "../../../ArtworkStatus/constant";
import ACPFilter from "../../../../components/ACP/common/ACPFilter";
import { AcpService } from "../../../../service/ACPService";
import { AcpCommonService } from "../../../../service/AcpCommonService";
import { getColumnsOrder, setColumnsOrder } from "../../../../apis/commonApi";
import { localWidthStorage } from "../../../../utils";
import { formCustomizeObject } from "../../../../utils";
import { Button } from "react-bootstrap";
import "./MaterialsTab.scss";
import { CharacterLimit } from "../../../../components/common/CharacterLimit/CharacterLimit";

const MaterialsTab = (props) => {
  const toast = useRef(null);
  const colAllSelected = useRef([]);
  const selectedFieldsRef = useRef([]);
  const [pegadata, setPegaData] = useState(null);
  const [isCICAddded, setIsCICAddded] = useState(false);
  const [isSpecialProject, setIsSpecialProject] = useState(false);
  const [initpegadata, setInitPegaData] = useState(null);
  const [config, setConfig] = useState({});
  const [ProjectFrozen, setProjectFrozen] = useState(false);
  const [frozenCoulmns, setFrozenColumn] = useState([]);
  const [selectedColumnName, setSelectedColumnName] = useState(null);
  const [materialsColumnName, setMaterialsColumnNames] = useState([]);
  const [selectedFields, setSelectedFields] = useState([]);
  const [filters, setFilters] = useState([]);
  const [filteredDataExport, setFilteredDataExport] = useState([]);
  const [visible, setVisible] = useState(false);
  const [sortData, setSortData] = useState([]);
  const [allColumnNamesMaterials, setAllColumnNames] = useState([]);
  const [updatedAllColumnNames, setUpdatedAllColumnNames] = useState([]);
  const [isReorderedColumn, setReorderedColumn] = useState(false);
  const [loader, setLoader] = useState(true);
  const [isColWidthSet, setColWidth] = useState(null);
  const [customViewIsAdded, isCustomViewIsAdded] = useState(false);
  const [openFullKitpopUp, setOpenFullkitPopUp] = useState(false);
  const [filterCleared, setFilterCleared] = useState(false);
  const [rowFullkitData, setRowFullkitData] = useState(null);
  const [fieldName, setFieldName] = useState(null);
  const [materialList, setMaterialList] = useState([]);
  const [tableRender, setTableRender] = useState(false);
  const [initialColumnLength, setinitialColumnLength] = useState({});
  const [customizeViewFields, setCustomizeViewFields] = useState([]);
  const [resizeMode, setResizeMode] = useState("fit");
  const [conditionMatched, setConditionMatched] = useState(false);
  const [datatableColumnFromPega, setDatatableColumnFromPega] = useState([]);
  const [pmpStatusComments, setPmpStatusComments] = useState({});
  const [pgDefaultColumns, setPgDefaultColumns] = useState({});
  const [settingsDialogVisible, setSettingsDialogVisible] = useState(false);
  const [materialsWrapFreeText, setMaterialsWrapFreeText] = useState(() => {
    const saved = sessionStorage.getItem("materialsWrapFreeText");
    return saved === "true";
  });
  const [first, setFirst] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [currentPage, setCurrentPage] = useState(0);
  const [resetKey, setResetKey] = useState(0);
  const allColumnsDataFromRedux = useSelector(
    (state) => state?.DropDownValuesReducer?.DropDownValuesData?.ArtworkAgilityMaterials,
  );
  const isSearch = useSelector((state) => state?.SearchFilterReducer?.dashboardMaterials);

  const allColumnsData = useMemo(() => {
    if (!allColumnsDataFromRedux || !Array.isArray(allColumnsDataFromRedux)) {
      return [];
    }
    return [...allColumnsDataFromRedux].sort((a, b) => (a?.Sequence || 0) - (b?.Sequence || 0));
  }, [allColumnsDataFromRedux]);

  useEffect(() => {
    sessionStorage.setItem("materialsWrapFreeText", materialsWrapFreeText);
  }, [materialsWrapFreeText]);

  const headerName = "Dashboard Materials";

  const ProjectID = "AWM-5104";
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const filterArray = useRef([]);
  const selectedColumnList = useRef([]);
  const currentUrl = useLocation().pathname.split("/");
  const {
    userDetails: { UserGroup, AccessGroup },
  } = useSelector((state) => state?.UserDetailsReducer);
  const { userInformation } = useSelector((state) => state.UserReducer);

  let isCIC = isCICAddded;

  const onSearchClick = useCallback(() => {
    dispatch({ type: types.ALTER_SEARCH_FILTER, page: "dashboardMaterials" });
    setResetKey((prev) => prev + 1);
  }, [isSearch]);

  const op = useRef(null);
  const dt = useRef(null);

  const onSort = (column, direction, filterData) => {
    let sortedData;
    if (filterData !== "globalClearFilter") {
      sortedData = filterData?.length ? filterData : filters?.length ? filters : pegadata;
    } else {
      sortedData = pegadata;
    }
    const sortedDataSet = AcpService.sortDataFirstStringThenNumeric(sortedData, column, direction);
    const finalSortedData = _.cloneDeep(sortedDataSet);

    setSortData([column, direction]);
    localStorage.setItem("sortingDataMaterials", JSON.stringify(true));
    if (filterData !== "globalClearFilter" && (filterData?.length || filters?.length)) {
      setFilters(finalSortedData);
      selectedColumnList.current = finalSortedData;
    } else {
      setPegaData(finalSortedData);
    }
    setFilteredDataExport(finalSortedData);
    // Reset pagination on sort
    setFirst(0);
    setCurrentPage(0);
  };

  const onPageChangeHandler = (event) => {
    const newFirst = event.first || 0;
    const newPage = Math.floor(newFirst / event.rows);
    setFirst(newFirst);
    setCurrentPage(newPage);
    setPageSize(event.rows);
  };

  useEffect(() => {
    let selectedFieldsNames = materialsColumnName.map((item) => item.Field_Name).filter(col => col !== "PiFPCID");
    const pgDefaultColumns = formCustomizeObject(["PiFPCID"], [], selectedFieldsNames);
    setPgDefaultColumns(pgDefaultColumns);
    setSelectedColumnName("");
  }, [pegadata, materialsColumnName]);

  const convertData = useCallback((data) => {
    return (data || [])?.map((el) => {
      return {
        ...el,
        Req: el?.Req ? el?.Req : el?.AWPrinterDate,
        ETA: el?.ETA ? el?.ETA : el?.POAReleaseDate,
      };
    });
  }, []);

  const fetchData = async () => {
    try {
      setLoader(true);
      const response = await getDashboardModuleDetails(userInformation.userid, "MT", "Max");
      const dashboardModules = response?.Dashboard?.DashboardModuleList || [];
      let updatedUsers = {};
      let config = {};
      let materialList = [];
      if (dashboardModules && dashboardModules.length > 0) {
        const module = dashboardModules[0];
        materialList = module.MaterialsList || [];
        config = { ...(module.Config || {}), Module_ID: module.Module_ID };
        updatedUsers = module;
      }
      const updatedData = sortColumns('BufferToWorkRatio','asc', convertData(materialList))
      setConfig(config);
      setInitPegaData(_.cloneDeep(updatedData));
      setFilteredDataExport(updatedData);
      setPegaData(updatedData);
      setMaterialList(updatedData);
      setLoader(false);
      setFilters([]);
      setSelectedFields([]);
    } catch (error) {
      setLoader(false);
      alert("Failed to load Material data. Please check your network connection and try again.");
    }
  };

  useEffect(() => {
    // Only call fetchData when we have all required data
    if (userInformation?.userid) {
      fetchData();
    }
  }, [userInformation?.userid]);

  useEffect(() => {
    const ProjectData = _.cloneDeep(materialList);
    let allCol = [];
    if (ProjectData.length) {
      allCol = Object.keys(ProjectData[0]);
    }
    if (!isCIC) {
      allCol = allCol.filter((item) => item !== "CIC");
    }
    if (isCIC && !allCol.includes("CIC")) allCol.splice(10, 0, "CIC");

    let columnWidthDBMaterials = {
      PIMaterialDescription: 200,
      POADescription: 200,
    };

    let getJsonStoredWidthColumns = localStorage.getItem("columnWidthDBMaterials");
    let getStoredWidthColumns = JSON.parse(getJsonStoredWidthColumns);
    const checkEmptyObject = _.isEmpty(getStoredWidthColumns);

    if (checkEmptyObject) {
      if (!isCIC) {
        getStoredWidthColumns = getStoredWidthColumns?.filter((item) => item !== "CIC");
      }
      if (isCIC && !getStoredWidthColumns?.includes("CIC"))
        getStoredWidthColumns?.splice(10, 0, "CIC");

      localStorage.setItem("columnWidthDBMaterials", JSON.stringify(columnWidthDBMaterials));
    }
    let jsonColWidth = localStorage.getItem("isColWidthSetDBMaterials");
    let isColWidthSetFlag = JSON.parse(jsonColWidth);
    if (isColWidthSetFlag) {
      setColWidth(true);
    }
  }, [materialList]);

  const reorderColumns = useCallback((columns) => {
    const requiredColumnOrderArray = allColumnsData?.length ? allColumnsData : [];
    let reorderedColumns = [];
    requiredColumnOrderArray.forEach((rcl) => {
      columns.forEach((cl) => {
        if (rcl.Field_Name === cl) {
          reorderedColumns.push(cl);
        }
      });
    });

    return reorderedColumns;
  }, []);

  useEffect(() => {
    setCustomizeViewFields(customizeViewFields);
  }, [customizeViewFields]);

  useEffect(() => {
    const fetchColumnFromPega = async () => {
      try {
        const datatableColumnFromPegaRes = await getColumnsOrder(
          userInformation?.userid,
          "allColumnNamesMaterials",
          "NA",
          "NA",
        );
        if (datatableColumnFromPegaRes != null && datatableColumnFromPegaRes?.length > 0) {
          setAllColumnNames(datatableColumnFromPegaRes);
          setDatatableColumnFromPega(datatableColumnFromPegaRes);
        } else {
          let localAllColumns = localStorage.getItem("allColumnNamesMaterials");
          let _allColumns = JSON.parse(localAllColumns);
          if (isEmpty(_allColumns)) {
            _allColumns = allColumnsData?.length ? allColumnsData : [];
          }
          setAllColumnNames(_allColumns);
        }
        const customizeViewMaterialsFieldsFromPega = await getColumnsOrder(
          userInformation?.userid,
          "customizeViewMaterialsFields",
          "NA",
          "NA",
        );
        if (
          customizeViewMaterialsFieldsFromPega != null &&
          customizeViewMaterialsFieldsFromPega !== ""
        ) {
          costomizeFrozenData();
          setCustomizeViewFields(JSON.stringify(customizeViewMaterialsFieldsFromPega));

          const selectedAndFrozenFields = [...customizeViewMaterialsFieldsFromPega?.selectedFields?.fieldsData, ...customizeViewMaterialsFieldsFromPega.freezedColumns.fieldsData]
          const orderedFields = allColumnsData.filter(colDetails => selectedAndFrozenFields.includes(colDetails?.Field_Name))
          setMaterialsColumnNames(orderedFields)
          localStorage.setItem("allColumnNamesMaterials", JSON.stringify(orderedFields));
        }
      } catch (error) {
        console.error("Error fetching column data from Pega:", error);
      }
    };

    fetchColumnFromPega();
  }, []);

  useEffect(() => {
    (async () => {
      try {
        //below is api call
        const ProjectData = _.cloneDeep(materialList);

        if (ProjectData.length) {
          let allCol = Object.keys(ProjectData[0]);

          if (!isCIC) {
            allCol = allCol.filter((item) => item !== "CIC");
          }
          if (isCIC && !allCol.includes("CIC")) allCol.splice(10, 0, "CIC");

          if (!allCol.includes("Design")) allCol.splice(9, 0, "Design");

          if (!allCol.includes("FA")) allCol.splice(12, 0, "FA");

          if (isEmpty(datatableColumnFromPega) || !datatableColumnFromPega)
            setAllColumnNames(reorderColumns(allCol));
        }

        let filteredPegaDataJson = localStorage.getItem("columnWiseFilterDataMaterials");
        const filteredPegaData = JSON.parse(filteredPegaDataJson);

        if (filteredPegaData && filteredPegaData.length) {
          setFilters(filteredPegaData);
          setFilteredDataExport(filteredPegaData);
        }

        // according to pathname we need to call api and store column name in local storage
        let columnNamesJson = localStorage.getItem("allColumnNamesMaterials");
        const columnNames = JSON.parse(columnNamesJson);
        const fieldToAdd = { Field_Name: "CIC" };

        if (columnNames != null && columnNames.length) {
          if (isCIC && !columnNames.some((item) => item.Field_Name === fieldToAdd.Field_Name)) {
            columnNames.splice(18, 0, fieldToAdd);
          }
          setMaterialsColumnNames(columnNames);
          setUpdatedAllColumnNames(columnNames);
        } else {
          let columnNames = allColumnsData?.length ? allColumnsData.filter(col => col?.Field_Name !== "PiFPCID") : [];

          if (!isCIC) {
            columnNames = columnNames.filter((item) => item.Field_Name !== "CIC");
          }
          if (isCIC && !columnNames.some((item) => item.Field_Name === fieldToAdd.Field_Name)) {
            columnNames.splice(15, 0, fieldToAdd);
          }

          localStorage.setItem("allColumnNamesMaterials", JSON.stringify(columnNames));
          setMaterialsColumnNames(columnNames);
          setUpdatedAllColumnNames(columnNames);
        }
        // get sort data from local storage and add in state
        let jsonSortingData1 = localStorage.getItem("sortingDataMaterials");
        const sortingDataMaterials = JSON.parse(jsonSortingData1);

        if (sortingDataMaterials && sortingDataMaterials.length) {
          const sortedData = [...ProjectData].sort((a, b) => {
            return a[sortingDataMaterials[0]] > b[sortingDataMaterials[0]] ? 1 : -1;
          });

          if (sortingDataMaterials[1] === "desc") {
            sortedData.reverse();
          }
          const updatedData = convertData(sortedData);
          setPegaData(updatedData);
          setSortData([sortingDataMaterials[0], sortingDataMaterials[1]]);
        }
      } catch (err) {}
    })();
  }, [materialList]);

  useEffect(() => {
    const parsedData =
      customizeViewFields !== "" && customizeViewFields?.length !== 0
        ? JSON.parse(customizeViewFields)
        : [];

    const selectedData = parsedData?.selectedFields?.fieldsData || [];
    const frozenData = parsedData?.freezedColumns?.fieldsData || [];
    const totalColumns = [...selectedData, ...frozenData];
    let columnNamesJson = localStorage.getItem("allColumnNamesMaterials");
    const allColumnNames = JSON.parse(columnNamesJson);
    const finalTotalColumns = totalColumns?.length > 0 ? totalColumns : allColumnNames; // if customizeviewfeilds are empty take it from localstorage AWM-3153
    if (finalTotalColumns?.length < 7) {
      setResizeMode("fit");
    } else {
      setResizeMode("expand");
    }
  }, [customizeViewFields]);

  const addFrozenColumns = useCallback(
    (name) => {
      if (!frozenCoulmns.includes(name)) {
        frozenCoulmns.push(name);
        setFrozenColumn(frozenCoulmns);
      } else {
        let columnIndex = frozenCoulmns.indexOf(name);
        frozenCoulmns.splice(columnIndex, 1);
        setFrozenColumn(frozenCoulmns);
      }
    },
    [frozenCoulmns],
  );

  const projectNameOnClick = useCallback((e, options) => {
    setFilterCleared(false);
    op.current.toggle(e);
    setSelectedColumnName(options);
  }, []);

  const StatusFlags = ({ state }) => {
    const { statusFlags, text } = getStatusFlags({ state }); // Pass state as an object
    return (
      <div>
        <span
          className={statusFlags}
          style={{
            padding: "10px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "8rem",
            fontSize: "1rem",
            textAlign: "center",
            borderRadius: "4px",
          }}
        >
          {text}
        </span>
      </div>
    );
  };

  const baseUrl = getBaseUrl("project");
  const projectIdCellTemplate = useMemo(() => projectIdCell(baseUrl), []);
  const projectNameCellTemplate = useMemo(() => projectNameCell(baseUrl), []);
  const artworkStatusCellTemplate = useMemo(() => artworkStatusCell(baseUrl), []);

  const fullKitReadinessBody = useCallback(
    (options, rowData) => {
      let field = rowData.field;

      const showRedIcon = options.ChangeHandlingIcon === "Red";
      const showGreyIcon =
        options.ChangeHandlingIcon === "Grey" || options.ChangeHandlingIcon === "Gray"; // Handle both spellings
      const showAlertIcon = showRedIcon || showGreyIcon;

      return (
        <>
          {field === "FAAssemblyState" && <StatusFlags state={options.FAAssemblyState} />}
          {field === "FAAssemblyEndDate" && (
            <span title={options[field]}>{options["FAAssemblyEndDate"]}</span>
          )}
          {field === "FAApprovalEndDate" && (
            <span title={options[field]}>{options["FAApprovalEndDate"]}</span>
          )}
          {field === "FAApproval" && <span>{options.FAApproval}</span>}
          {field === "CountryOfSales" && (
            <span title={options.CountryOfSales}>{options.CountryOfSales}</span>
          )}
          {field === "ApprovedCopyElements" && (
            <span title={options.ApprovedCopyElements + "/" + options.TotalCopyElements}>
              {options.ApprovedCopyElements + "/" + options.TotalCopyElements}
            </span>
          )}
          {field === "PIFPCNumber" && <span title={options[field]}>{options["PiFPCNumber"]}</span>}
          {/* {field === "AWPrinterDate" && <span title={options[field]}>{options[field]}</span>} */}

          {field === "ETA" && <span title={options[field]}>{options["ETA"]}</span>}
          {field === "Req" && <span title={options[field]}>{options["Req"]}</span>}
          {field === "Estimated_AW_Printer" && (
            <span title={changeDateFormat(options[field])}>
              {changeDateFormat(options["Estimated_AW_Printer"])}
            </span>
          )}
          {field === "POATOBVEStatus" && (
            <span title={options[field]}>{options["POATOBVEStatus"]}</span>
          )}
          {field === "POATOBVEEndDate" && (
            <span title={options[field]}>{options["POATOBVEEndDate"]}</span>
          )}
          {field === "DispatchFAToPrinterStatus" && (
            <span title={options[field]}>{options["DispatchFAToPrinterStatus"]}</span>
          )}
          {field === "DispatchFAToPrinterEndDate" && (
            <span title={options[field]}>{options["DispatchFAToPrinterEndDate"]}</span>
          )}
          {field === "BufferToWorkRatio" && bufferToWork(options[field])}

          {field === "FAFlag" && (
            <div
              className="cic-tooltip-target"
              title={materialsExportCSVFlags(options["FAFlag"], isSpecialProject)}
            >
              {options["FAFlag"] === "NA" ? (
                <div>{options["FAFlag"]}</div>
              ) : options["FAFlag"]?.includes("|") ? (
                <>
                  <div
                    className={isSpecialProject === true ? "hide-popup" : "show-popup"}
                    onClick={() => {
                      setOpenFullkitPopUp(true);
                      setRowFullkitData(options);
                      setFieldName("fa");
                    }}
                  >
                    {options["FAFlag"]}
                  </div>
                </>
              ) : (
                <div
                  className={isSpecialProject === true ? "hide-popup" : "show-popup"}
                  onClick={() => {
                    setOpenFullkitPopUp(true);
                    setRowFullkitData(options);
                    setFieldName("fa");
                  }}
                >
                  <div
                    onClick={() => {
                      if (options["FAFlag"] === "GreenV") {
                        navigate(`/${currentUrl[1]}/projectPlan/${ProjectID}`);
                      } else {
                        setOpenFullkitPopUp(true);
                        setRowFullkitData(options);
                        setFieldName("fa");
                      }
                    }}
                  >
                    <div className="footerIconsMain">
                      <div>
                        <i className={`footerIconAll ${cicImage(options["FAFlag"])}`}></i>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}

          {field === "DesignFlag" && (
            <div
              className="cic-tooltip-target"
              title={materialsExportCSVFlags(options["DesignFlag"], isSpecialProject)}
            >
              {options["DesignFlag"] === "NA" ? (
                <div>{options["DesignFlag"]}</div>
              ) : (
                <div className="footerIconsMain">
                  <div>
                    <i className={`${cicImage(options["DesignFlag"])}`}></i>
                  </div>
                </div>
              )}
            </div>
          )}

          {field === "CICFlag" && (
            <div className="cic-img">
              <div
                className="cic-tooltip-target"
                title={materialsExportCSVFlags(options["CICFlag"], isSpecialProject)}
              >
                {options["CICFlag"] === "NA" || options["CICFlag"] === "" || !options["CICFlag"] ? (
                  <div>{options["CICFlag"]}</div>
                ) : options["CICFlag"]?.includes("|") ? (
                  <>
                    <div
                      className={isSpecialProject === true ? "hide-popup" : "show-popup"}
                      onClick={() => {
                        setOpenFullkitPopUp(true);
                        setRowFullkitData(options);
                        setFieldName("cic");
                      }}
                    >
                      {options["CICFlag"]}
                    </div>
                  </>
                ) : (
                  <>
                    <div
                      className={isSpecialProject === true ? "hide-popup" : "show-popup"}
                      onClick={() => {
                        setOpenFullkitPopUp(true);
                        setRowFullkitData(options);
                        setFieldName("cic");
                      }}
                    >
                      <div className="footerIconsMain">
                        <div>
                          <i className={`${cicImage(options["CICFlag"])}`}></i>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          )}

          {field === "PIMaterialNumber" && (
            <>
              <div className="snapshot-icons" disabled={props?.userHasAccess}>
                <span title={options[field]} className="text-option">
                  {options[field]}
                </span>
              </div>
              {showAlertIcon && (
                <AlertIcon
                  iconType="error"
                  showAlertIcon={showAlertIcon}
                  onClick={() => {
                    const pmpId = options.PIMaterialID;
                    const currentUrlString = currentUrl.join("/");
                    const targetPath = `/${currentUrl[1]}/artworkStatus/ChangeHandling/${userInformation?.userid}/${ProjectID}`;

                    navigate(targetPath, {
                      state: {
                        PIMaterialID: pmpId,
                        from: "artworkstatusPage",
                        assignee: userInformation?.userid,
                        InitiativeID: options?.DSBP_InitiativeID,
                        DSBP_PMP_PIMaterialID: pmpId,
                        previousUrl: currentUrlString, // Store the current artwork status URL
                      },
                    });
                  }}
                  editable={showGreyIcon}
                  tooltipClass="tooltip-white"
                  tooltipText={
                    showGreyIcon
                      ? dsbpConstant.xml_awaiting_response_enovia
                      : dsbpConstant.xml_view_changes
                  }
                  tooltipPosition={"top"}
                />
              )}
            </>
          )}

          {field !== "Artwork_Status" &&
            field !== "ApprovedCopyElements" &&
            field !== "POAReleaseDate" &&
            field !== "AWPrinterDate" &&
            field !== "CIC" &&
            field !== "CICFlag" &&
            field !== "FAFlag" &&
            field !== "FAAssemblyState" &&
            field !== "FAAssemblyEndDate" &&
            field !== "FAApprovalEndDate" &&
            field !== "CountryOfSales" &&
            field !== "FAApproval" &&
            field !== "AWMProjectID" &&
            field !== "AWMProjectName" &&
            field !== "PIMaterialNumber" &&
            field !== "DesignFlag" &&
            field !== "Design" &&
            field !== "ETA" &&
            field !== "Action" &&
            field !== "Req" &&
            field !== "Estimated_AW_Printer" &&
            field !== "POATOBVEStatus" &&
            field !== "POATOBVEEndDate" &&
            field !== "DispatchFAToPrinterStatus" &&
            field !== "DispatchFAToPrinterEndDate" &&
            field !== "BufferToWorkRatio" &&
            field !== "FA" && (
              <>
                {" "}
                <span title={options[field]}>{options[field]}</span>{" "}
              </>
            )}
          {field === "ProjectID" && <span title={options.ProjectID}>{options.ProjectID}</span>}
          {field === "AWMProjectID" && projectIdCellTemplate(options)}
          {field === "AWMProjectName" && projectNameCellTemplate(options)}
          {field === "Action" && artworkStatusCellTemplate(options)}

          {field === "CICApprovalStatus" && (
            <span title={options.CICApprovalStatus}>{options.CICApprovalStatus}</span>
          )}
          {field === "Rework" && <span title={options.Rework}>{options.Rework}</span>}
          {field === "SupportingPMP" && (
            <span title={options.SupportingPMP}>{options.SupportingPMP}</span>
          )}
          {field === "CICNeededFlag" && (
            <span title={options.CICNeededFlag}>{options.CICNeededFlag}</span>
          )}
          {field === "POAReleaseDate" && (
            <span title={changeDateFormat(options.POAReleaseDate)}>{changeDateFormat(options.POAReleaseDate)}</span>
          )}
          {field === "AWPrinterDate" && (
            <span title={changeDateFormat(options.AWPrinterDate)}>{changeDateFormat(options.AWPrinterDate)}</span>
          )}
        </>
      );
    },
    [isSpecialProject, currentUrl, ProjectID, navigate, userInformation],
  );

  const costomizeFrozenData = useCallback(() => {
    let jsonValue;
    if (customizeViewFields !== undefined && customizeViewFields?.length !== 0) {
      jsonValue = customizeViewFields ? JSON.parse(customizeViewFields) : null;
    }
    let freezedData;
    if (jsonValue && Object.keys(jsonValue)?.length !== 0) {
      freezedData = jsonValue?.freezedColumns?.fieldsData || [];
      freezedData && setFrozenColumn(freezedData);
      localStorage.setItem("frozenDataDashboardMaterials", JSON.stringify(freezedData));
    }
    return freezedData;
  }, [customizeViewFields]);

  useEffect(() => {
    costomizeFrozenData();
    if (customizeViewFields && customizeViewFields === "[]") {
      setFrozenColumn([]);
      localStorage.setItem("frozenDataDashboardMaterials", JSON.stringify({}));
    }
    const parsedData =
      customizeViewFields !== "" && customizeViewFields?.length !== 0
        ? JSON.parse(customizeViewFields)
        : [];
    let selectedData = parsedData?.selectedFields?.fieldsData;
    if (
      Object.keys(initialColumnLength).length > 0 &&
      selectedData?.length > 0 &&
      initialColumnLength?.selectedFields !== selectedData?.length
    ) {
      isCustomViewIsAdded(true);
    } else {
      isCustomViewIsAdded(false);
    }
  }, [customizeViewFields]);

  const dynamicColumns = useMemo(() => {
    const localColumnWidth = localStorage.getItem("columnWidthDBMaterials");
    let columnWidth = {};
    if (localColumnWidth) {
      columnWidth = JSON.parse(localColumnWidth);
    }
    const columnWidthKeys = Object.keys(columnWidth);

    const uniqueArray = [...new Set(materialsColumnName)];

    let jsonValue;
    if (customizeViewFields !== undefined && customizeViewFields?.length !== 0) {
      jsonValue = customizeViewFields ? JSON.parse(customizeViewFields) : null;
    }

    if (jsonValue && Object.keys(jsonValue).length !== 0) {
      let selectedData = jsonValue?.selectedFields?.fieldsData || [];
      let freezedData = jsonValue?.freezedColumns?.fieldsData || [];
      const mergedData = [...freezedData, ...selectedData];

      const filteredColumns = [];
      // Add freezedData columns in the specified order
      // freezedData && setFrozenColumn(freezedData);
      mergedData?.forEach((fieldName) => {
        const column = uniqueArray?.find((col) => col.Field_Name === fieldName);
        if (column) {
          filteredColumns.push(column);
        }
      });
      if (filteredColumns && filteredColumns.length) {
        return filteredColumns?.map((ele, i) => {
          return (
            <Column
              key={ele.Field_Name}
              field={ele.Field_Name}
              filterField={ele.Field_Name}
              header={MaterialsNameHeader(
                ele.Field_Name,
                frozenCoulmns,
                sortData,
                projectNameOnClick,
                selectedFields,
              )}
              columnKey={ele.Field_Name || i}
              frozen={frozenCoulmns?.includes(ele.Field_Name)}
              alignFrozen="left"
              className={frozenCoulmns?.includes(ele.Field_Name) ? "font-bold frozen-width" : ""}
              filter
              showFilterMenu={false}
              filterPlaceholder={ele.Field_Name}
              body={fullKitReadinessBody}
              style={{
                width:
                  columnWidthKeys.includes(ele.Field_Name) &&
                  columnWidth &&
                  columnWidth[ele.Field_Name],
                maxWidth:
                  columnWidthKeys.includes(ele.Field_Name) &&
                  columnWidth &&
                  columnWidth[ele.Field_Name],
                whiteSpace: materialsWrapFreeText ? "normal" : "nowrap",
                wordBreak: materialsWrapFreeText ? "break-word" : "unset",
                overflow: materialsWrapFreeText ? "unset" : "hidden",
                textOverflow: materialsWrapFreeText ? "unset" : "ellipsis",
              }}
            />
          );
        });
      }
    } else {
      if (uniqueArray && uniqueArray?.length) {
        return uniqueArray?.map((ele, i) => {
          if (!isCIC && ele.Field_Name === "CIC") {
            // Skip rendering the column
            return null;
          }
          return (
            <Column
              key={ele.Field_Name}
              field={ele.Field_Name}
              filterField={ele.Field_Name}
              header={MaterialsNameHeader(
                ele.Field_Name,
                frozenCoulmns,
                sortData,
                projectNameOnClick,
                selectedFields,
              )}
              columnKey={ele.Field_Name || i}
              frozen={frozenCoulmns?.includes(ele.Field_Name)}
              alignFrozen="left"
              className={frozenCoulmns?.includes(ele.Field_Name) ? "font-bold frozen-width" : ""}
              filter
              showFilterMenu={false}
              filterPlaceholder={ele.Field_Name}
              body={fullKitReadinessBody}
              style={{
                width:
                  columnWidthKeys.includes(ele.Field_Name) &&
                  columnWidth &&
                  columnWidth[ele.Field_Name],
                maxWidth:
                  columnWidthKeys.includes(ele.Field_Name) &&
                  columnWidth &&
                  columnWidth[ele.Field_Name],
                whiteSpace: materialsWrapFreeText ? "normal" : "nowrap",
                wordBreak: materialsWrapFreeText ? "break-word" : "unset",
                overflow: materialsWrapFreeText ? "unset" : "hidden",
                textOverflow: materialsWrapFreeText ? "unset" : "ellipsis",
              }}
            />
          );
        });
      }
    }
  }, [
    materialsColumnName,
    frozenCoulmns,
    sortData,
    projectNameOnClick,
    materialsWrapFreeText,
    selectedFields,
  ]);

  const clearFiltersResetToDefault = useCallback(
    (param) => {
      const allColumnNamesMaterials = allColumnsData?.length ? allColumnsData.filter(col => col?.Field_Name !== "PiFPCID") : [];
      let columnWidthDBMaterials = {
        PIMaterialDescription: 200,
        POADescription: 200,
      };
      setMaterialsColumnNames(allColumnNamesMaterials);
      localStorage.setItem("allColumnNamesMaterials", JSON.stringify(allColumnNamesMaterials));
      localStorage.setItem("columnWiseFilterDataMaterials", JSON.stringify({}));
      const costomizeFrozenData1 = costomizeFrozenData();

      if (costomizeFrozenData1 === undefined) {
        setFrozenColumn([]);
        localStorage.setItem("frozenDataDashboardMaterials", JSON.stringify({}));
      }
      localStorage.setItem("sortingDataMaterials", JSON.stringify({}));
      localStorage.setItem("frozenDataDashboardMaterials", JSON.stringify({}));
      selectedFieldsRef.current = [];
      if (param === "globalReset") {
        localStorage.removeItem("isColWidthSetDBMaterials");
        localStorage.setItem("columnWidthDBMaterials", JSON.stringify(columnWidthDBMaterials));
        setFilters([]);
        setSortData([]);
      }
      setColWidth(false);
      setSelectedFields([]);
      setReorderedColumn(false);
      setVisible(false);
      setFilterCleared(true);
      const updatedData = convertData(initpegadata);
      setFilteredDataExport(updatedData);
      setPegaData(updatedData);
      dispatch({ type: types.HIDE_SEARCH_FILTER, page: "dashboardMaterials" });
      setCustomizeViewFields([]);
      setFrozenColumn([]);
      setProjectFrozen(false);
      setResizeMode("expand");
      setResetKey((prev) => prev + 1);
    },
    [convertData, initpegadata],
  );

  const reorderColumnsSetColumnOrder = async (entities) => {
    const selectedAndFrozenColumns = [...entities?.columns?.selectedFields?.fieldsData, ...entities?.columns?.freezedColumns?.fieldsData]
    const orderedFields = allColumnsData.filter(colDetails => selectedAndFrozenColumns.includes(colDetails?.Field_Name))

    setMaterialsColumnNames(orderedFields)

    localStorage.setItem("allColumnNamesMaterials", JSON.stringify(orderedFields));

    await setColumnsOrder(
      userInformation?.userid,
      "allColumnNamesMaterials",
      "NA",
      "NA",
      false,
      JSON.stringify(orderedFields),
    );
    await setColumnsOrder(
      userInformation?.userid,
      "customizeViewMaterialsFields",
      "NA",
      "NA",
      false,
      JSON.stringify(entities.columns),
    );
    if (!checkIfObjectOrderSame(allColumnsData?.length ? allColumnsData : [], orderedFields)) {
      isCustomViewIsAdded(true);
    } else {
      isCustomViewIsAdded(false);
    }
    setResetKey((prev) => prev + 1);
  };

  const onGlobalFilterChange = useCallback(
    (e, colName) => {
      const { value, multiplesFlag, arr } = multiFilterChange(
        e,
        colName,
        selectedColumnName,
        selectedFields,
        setSelectedFields,
        pegadata,
        filterArray,
        selectedColumnList,
        colAllSelected,
        selectedFieldsRef,
      );
      const _selectedFieldsRef = (selectedFieldsRef?.current || []).map((el, i) => {
        if (Object.keys(arr)?.[0] === Object.keys(el)?.[0]) {
          return {
            ...el,
            [`${selectedColumnName}`]: arr[selectedColumnName],
          };
        } else {
          return el;
        }
      });
      if (AcpService.areAllPropertiesEmptyArrays(_selectedFieldsRef)) {
        localStorage.removeItem("_selectedFieldsRefCurrentArtworkStatus");
      }
      if (filterArray.current?.length) {
        if ((value?.length > 0 && !multiplesFlag) || colAllSelected.current?.length >= 1) {
          const _selectedFieldsRefWithoutEmptyArray =
            AcpService.removeEmptyArrays(_selectedFieldsRef);
          const _selectedFieldsRefWithUniqueObjects = AcpService.getUniqueObjects(
            _selectedFieldsRefWithoutEmptyArray,
          );
          const filterData = AcpService.filterDataByfilters(
            pegadata,
            _selectedFieldsRefWithUniqueObjects,
            setConditionMatched,
            "artworkStatus",
          );

          const convertedObj = AcpCommonService.convertArrayToObject(
            _selectedFieldsRefWithoutEmptyArray,
          );
          const uniqueObj = AcpCommonService.getUniqueValuesObject(convertedObj);
          setSelectedFields(uniqueObj);
          setFilteredDataExport(filterData);
          if (filterData?.length && sortData?.length) {
            onSort(sortData[0], sortData[1], filterData);
          } else {
            setFilters(filterData);
            selectedColumnList.current = filterData;
          }
        } else {
          selectedColumnList.current = [];
          selectedFieldsRef.current = [];
          setFilteredDataExport([]);
          setSelectedFields({});
          setFilters([]);
        }
      } else {
        selectedColumnList.current = [];
        selectedFieldsRef.current = [];
        setFilteredDataExport([]);
        setSelectedFields({});
        setFilters([]);
      }
    },
    [selectedColumnName, selectedFields, pegadata, sortData, onSort],
  );

  const handleChildClick = useCallback(
    (isClicked) => {
      if (!isClicked) {
        clearFilter();
        if (isSearch) {
          setResetKey((prev) => prev + 1);
        }
      }
    },
    [isSearch, initpegadata],
  );

  const onColumnResizeEnd = useCallback(
    (event) => {
      let columnWidthDBMaterials = {};
      localWidthStorage(event, "columnWidthDBMaterials");
      localStorage.setItem("isColWidthSetDBMaterials", JSON.stringify(true));
      setColWidth(true);
      setMaterialsColumnNames(materialsColumnName);
      setVisible(false);
    },
    [materialsColumnName],
  );

  const saveSettings = useCallback(() => {
    localStorage.setItem("columnWiseFilterDataMaterials", JSON.stringify(filters));
    localStorage.setItem("frozenDataDashboardMaterials", JSON.stringify(frozenCoulmns));
    localStorage.setItem("sortingDataMaterials", JSON.stringify(sortData));
    localStorage.setItem("allColumnNamesMaterials", JSON.stringify(materialsColumnName));
  }, [filters, frozenCoulmns, sortData, materialsColumnName]);

  const storeReorderedColumns = useCallback(
    (e) => {
      const dragColumnName = materialsColumnName[e?.dragIndex];
      const index = materialsColumnName.indexOf(dragColumnName);
      if (index > -1) {
        // only splice array when item is found
        materialsColumnName.splice(index, 1); // 2nd parameter means remove one item only
        materialsColumnName.splice(e?.dropIndex, 0, dragColumnName);
        setReorderedColumn(true);
      }
      localStorage.setItem("allColumnNamesMaterials", JSON.stringify(materialsColumnName));
      setMaterialsColumnNames(materialsColumnName);
    },
    [materialsColumnName],
  );

  const clearFilter = useCallback(() => {
    selectedFieldsRef.current = [];
    setSelectedFields([]);
    setFilters([]);
    const updatedData = convertData(initpegadata);
    setFilteredDataExport(updatedData);
    setPegaData(updatedData);
    dispatch({ type: types.HIDE_SEARCH_FILTER, page: "dashboardMaterials" });
    if (sortData?.length) {
      onSort(sortData[0], sortData[1], "globalClearFilter");
    }
  }, [initpegadata, sortData]);

  const clearColumnWiseFilter = async () => {
    let jsonFrozenItem = localStorage.getItem("frozenDataDashboardMaterials");
    const frozenItem = JSON.parse(jsonFrozenItem);
    let _selectedColumnName = selectedColumnName;

    if (frozenItem && frozenItem?.length && frozenItem.includes(_selectedColumnName)) {
      const index = frozenItem.indexOf(_selectedColumnName);
      frozenItem.splice(index, 1);
      setFrozenColumn(frozenItem);
      localStorage.setItem("frozenDataDashboardMaterials", JSON.stringify(frozenItem));
    }
    if (frozenCoulmns.includes(_selectedColumnName)) {
      const index = frozenCoulmns.indexOf(_selectedColumnName);
      frozenCoulmns.splice(index, 1);
      setFrozenColumn(frozenCoulmns);
      setProjectFrozen(!ProjectFrozen);
      const availableColumnNamesData = JSON.parse(customizeViewFields)?.availableFields?.fieldsData;
      const freezedColumnsNamesData = frozenCoulmns?.filter((el) => el !== "SelectAll");
      const selectedFieldsNames = JSON.parse(
        customizeViewFields,
      )?.selectedFields?.fieldsData?.filter((el) => el !== "SelectAll");
      let selectedFieldsNamesData = [...selectedFieldsNames, _selectedColumnName];
      const finalData = {
        availableFields: {
          fieldsData: availableColumnNamesData,
          id: "availableFields",
          title: "Available Fields",
        },
        freezedColumns: {
          fieldsData: freezedColumnsNamesData,
          id: "freezedColumns",
          title: "Freezed Fields",
        },
        selectedFields: {
          fieldsData: selectedFieldsNamesData,
          id: "selectedFields",
          title: "Selected Fields",
        },
      };
      setCustomizeViewFields(JSON.stringify(finalData));
      localStorage.setItem("customizeViewMaterialsFields", JSON.stringify(finalData));
    }
    if (sortData && sortData?.length && sortData[0] === _selectedColumnName) {
      localStorage.removeItem("sortingDataMaterials");
      setSortData([]);
    }

    const selectedFields2 = _.cloneDeep(selectedFields);
    const uniqueObj = AcpCommonService.getUniqueValuesObject(selectedFields2);
    const _selectedFields = AcpService.emptyProperty(uniqueObj, _selectedColumnName);
    const __selectedFields = AcpCommonService.removeEmptyArraysWithNoData(_selectedFields);
    selectedFieldsRef.current = __selectedFields;
    setSelectedFields(__selectedFields);
    if (AcpService.areAllPropertiesEmptyArrays(__selectedFields)) {
      localStorage.removeItem("_selectedFieldsRefCurrentArtworkStatus");
    }
    let data = [...(pegadata || [])];
    Object.keys(__selectedFields).forEach((el) => {
      if (__selectedFields[el]?.length) {
        data = data.filter((ele) => __selectedFields[el].includes(ele[el]));
      }
    });
    if (data?.length && Object.keys(__selectedFields)?.length) {
      setFilters(data);
      setFilteredDataExport(data);
    } else if (sortData?.length && sortData[0] !== _selectedColumnName) {
      selectedColumnList.current = pegadata;
      setFilters([]);
      onSort(sortData[0], sortData[1], pegadata);
    } else {
      const finalInitData = _.cloneDeep(initpegadata);
      const updatedData = convertData(finalInitData);
      selectedColumnList.current = updatedData;
      setFilteredDataExport(updatedData);
      selectedFieldsRef.current = [];
      setPegaData(updatedData);
      setSelectedFields({});
      setFilters([]);
    }
    setConditionMatched(false);
  };

  // Check if there are any comments that have been changed from their original values
  const hasCommentsToSave = useMemo(
    () => pmpStatusComments && Object.keys(pmpStatusComments).length > 0,
    [pmpStatusComments],
  );

  const isFilterEnabled = useMemo(() => filters?.length || isSearch, [filters, isSearch]);

  const isResetEnabled = useMemo(
    () => isFilterEnabled || frozenCoulmns?.length || customViewIsAdded,
    [isFilterEnabled, frozenCoulmns, customViewIsAdded],
  );

  const timestamp = new Date().getTime();

  const materialsStatusfooter = useMemo(
    () => (
      <div>
        <div className="footerIcons">
          {!isSpecialProject && (
            <div className="footerIconsMain footIcon">
              <div>
                <i className="pi pi-info footerIconAll footerIcons2"></i>
              </div>
              <div className="footerIconsContent1">Snapchange alert is true</div>
            </div>
          )}
          <div className="footerIconsMain footIcon">
            <div>
              <i className="pi pi-check footerIconAll footerIcons3"></i>
            </div>
            <div className="footerIconsContent1">{greenV}</div>
          </div>

          {!isSpecialProject && (
            <div className="footerIconsMain footIcon">
              <div>
                <i className="pi pi-times footerIconAll footerIcons4"></i>
              </div>
              <div className="footerIconsContent1">{redCross}</div>
            </div>
          )}

          {!isSpecialProject && (
            <div className="footerIconsMain footIcon">
              <div>
                <i className="pi pi-circle-off footerIconAll footerIcons5"></i>
              </div>
              <div className="footerIconsContent1">{hallowGreenCircle}</div>
            </div>
          )}

          {!isSpecialProject && (
            <div className="footerIconsMain footIcon">
              <div>
                <i className="pi pi-circle-off footerIconAll footerIcons6"></i>
              </div>
              <div className="footerIconsContent1">
                <span> {hallowRedCircle}</span>
              </div>
            </div>
          )}

          <div className="footerIconsMain footIcon ">
            <div>
              <i className="pi pi-circle-off footerIconAll footerIcons7"></i>
            </div>
            <div className="footerIconsContent1">
              <span>{isSpecialProject ? UnallocatedHallowGreyCircle : hallowGreyCircle}</span>
            </div>
          </div>

          <div className="footerIconsMain footIcon">
            <div>
              <i className="pi pi-circle-on footerIconAll footerIcons8"></i>
            </div>
            <div className="footerIconsContent1">
              <span style={{ paddingTop: "10px" }}>
                {isSpecialProject ? UnallocatedSolidGreenCircle : solidGreenCircle}
              </span>
            </div>
          </div>

          {!isSpecialProject && (
            <div className="footerIconsMain footIcon">
              <div>
                <i className="pi pi-circle-on footerIconAll footerIcons9"></i>
              </div>
              <div className="footerIconsContent1">
                <span>{inProgressLate}</span>
              </div>
            </div>
          )}

          <div className="footerIconsMain footIcon">
            <div className="footerIcons10 footerIconAll">
              <span>2/1/0</span>
            </div>
            <div className="footerIconsContent1">
              <span>Approvers / Approved / Rejected</span>
            </div>
          </div>

          <div className="footerIconsMain footIcon">
            <div className="footerIcons11 footerIconAll">
              <span>N/A</span>
            </div>
            <div className="footerIconsContent1">
              <span>{isSpecialProject ? UnallocatedNA : NA}</span>
            </div>
          </div>
        </div>
        <div className="recordfooter">
          {!loader && (filters?.length > 0 || pegadata?.length > 0) && (
            <Footer
              className="footer"
              isSelected={false}
              totalObjects={(filters?.length ? filters : pegadata)?.length}
            />
          )}
        </div>
      </div>
    ),
    [isSpecialProject, loader, filters, pegadata, hasCommentsToSave],
  );

  const isConfigEmpty = !config || (typeof config === "object" && Object.keys(config).length === 0);
  return (
    <div className={`materialsContainer`}>
      <Toast ref={toast} />
      <LoadingOverlay active={loader || materialList?.data?.length === 0} spinner text="">
        {isConfigEmpty ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: loader ? "100vh" : "calc(100vh - 320px)",
              fontSize: "18px",
              color: "#6c757d",
            }}
          >
            <div style={{ textAlign: "center" }}>
              <i
                className="pi pi-cog"
                style={{ fontSize: "48px", marginBottom: "20px", display: "block" }}
              ></i>
              <p>Please configure your materials settings to view data</p>
              <Button
                variant="primary"
                onClick={() => setSettingsDialogVisible(true)}
                style={{ marginTop: "10px", display: "block", margin: "10px auto 0" }}
              >
                Open Settings
              </Button>
            </div>
          </div>
        ) : (
          <Suspense fallback={<div />}>
            {pegadata !== undefined && (
              <MaterialsListHeader
                isSearch={isSearch}
                clearFiltersResetToDefault={clearFiltersResetToDefault}
                clearFilter={clearFilter}
                setVisible={setVisible}
                saveSettings={saveSettings}
                onSearchClick={onSearchClick}
                isFilterEnabled={isFilterEnabled}
                isResetEnabled={isResetEnabled}
                allData={conditionMatched ? [] : filters?.length ? filters : pegadata}
                headers={allColumnNamesMaterials}
                filterFLag={false}
                CustomizeViewFlag={false}
                ResetToDefaultFlag={true}
                isTreeTableFlag={false}
                projectColumnName={materialsColumnName}
                headerName={headerName}
                customizeViewFields={customizeViewFields}
                setCustomizeViewFields={setCustomizeViewFields}
                selected={conditionMatched ? [] : filters?.length && filters}
                onChildClick={handleChildClick}
                setTableRender={setTableRender}
                tableRender={tableRender}
                isSpecialProject={isSpecialProject}
                bu={"NA"} //bu and region passed as props for setColumnsOrder and getColumnsOrder API in DragAndDrop component
                region={"NA"}
                reorderColumnsSetColumnOrder={reorderColumnsSetColumnOrder}
                pgDefaultColumns={pgDefaultColumns}
                materialsWrapFreeText={materialsWrapFreeText}
                setMaterialsWrapFreeText={setMaterialsWrapFreeText}
                pmpStatusComments={pmpStatusComments}
                setSettingsDialogVisible={setSettingsDialogVisible}
              />
            )}
            <ACPFilter
              op={op}
              onSort={onSort}
              filters={filters}
              sortData={sortData}
              projectData={pegadata}
              setFilters={setFilters}
              setSortData={setSortData}
              pageName={"artworkStatus"}
              saveSettings={saveSettings}
              ProjectFrozen={ProjectFrozen}
              frozenCoulmns={[]}
              selectedFields={selectedFields}
              selectAllColumnNotIncluded={true}
              setFrozenColumn={setFrozenColumn}
              setProjectFrozen={setProjectFrozen}
              addFrozenColumns={addFrozenColumns}
              selectedColumnName={selectedColumnName}
              onGlobalFilterChange={onGlobalFilterChange}
              clearColumnWiseFilter={clearColumnWiseFilter}
            />

            <DataTable
              ref={dt}
              value={conditionMatched ? [] : filters?.length ? filters : pegadata}
              scrollable
              scrollHeight="flex"
              resizableColumns
              columnResizeMode="expand"
              reorderableColumns
              dataKey="PIMaterialID"
              id={`${isSpecialProject && "special-project"}`}
              className={`awm-dashboard-grid projectTable myProjectAnddAllProjectList`}
              tableStyle={{
                minWidth: "100%",
                width: "max-content",
              }}
              paginator={true}
              first={first}
              rows={pageSize}
              onPage={onPageChangeHandler}
              totalRecords={pegadata?.length || 0}
              rowsPerPageOptions={[10, 20, 50, 100, 200]}
              paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords} records"
              footer={materialsStatusfooter}
              filterDisplay={isSearch && "row"}
              onColReorder={storeReorderedColumns}
              onColumnResizeEnd={onColumnResizeEnd}
              key={filterCleared || tableRender ? `"PIMaterialID" +${resetKey}` : `${resetKey}`}
              emptyMessage="No materials match your selected criteria."
            >
              {dynamicColumns}
            </DataTable>
          </Suspense>
        )}
        {/* Settings Dialog */}
        <CreateViewDialog
          visible={settingsDialogVisible}
          selectedOption="materials"
          onHide={() => setSettingsDialogVisible(false)}
          isUpdateMode={!!config && typeof config === "object" && Object.keys(config).length > 0}
          settings={config}
          reloadDashboard={fetchData}
          toastRef={toast}
        />
      </LoadingOverlay>
    </div>
  );
};
export default MaterialsTab;
